import React, { ReactNode, useState } from "react";
import axios from "axios";
import { Alerta, Botao, Box, TipoAlerta, TipoBotao } from "@intechprev/componentes-web";

import config from "../../../../config.json";

interface IProps {
  texto: ReactNode;
  titulo: string;
  id: string;
  setOidArquivoUpload: (s: string) => void;
}

export const ArquivoUpload: React.FC<IProps> = ({
  texto,
  titulo,
  id,
  setOidArquivoUpload
}) => {
  let fileUpload: any;

  const ID = "selecionar-" + id;

  const [Visible, setVisible] = useState<boolean>(true);
  const [Uploading, setUploading] = useState<boolean>(false);

  async function uploadFile() {
    setUploading(true);
    try {
      const arquivoUpload = fileUpload.files[0];

      const formData = new FormData();
      formData.append("file", arquivoUpload);

      const app = `@${config.appName}:token`;
      const token = localStorage.getItem(app);

      const result = await axios.post(config.apiUrl + "/emprestimo/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        // onUploadProgress: async (progressEvent) => {
        //   await this.setState({
        //     uploadPercentage: Math.round((progressEvent.loaded * 100) / progressEvent.total),
        //   });
        // },
      });

      setVisible(false);
      setUploading(false);
      setOidArquivoUpload(result.data);
    } catch (err) {
      alert(err.response ? err.response.data : err);
      setVisible(true);
      setUploading(false);
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box titulo={titulo}>
      <div className={"alert alert-info"}>{texto}</div>

      {Visible && !Uploading && (
        <input
          name={ID}
          id={ID}
          type={"file"}
          onChange={uploadFile}
          ref={(ref) => (fileUpload = ref)}
        />
      )}

      {Visible && Uploading && <div>Carregando...</div>}

      {!Visible && !Uploading && (
        <div>
          <Alerta tipo={TipoAlerta.success} mensagem={"Arquivo enviado com sucesso"} />
          <Botao
            titulo={"Enviar outro arquivo"}
            tipo={TipoBotao.primary}
            onClick={async () => {
              setVisible(true);
              setOidArquivoUpload("")
            }
            }
          />
        </div>
      )}
    </Box>
  );
}